<script>
import $ from 'jQuery';
import { Popover } from 'vue-bootstrap';

export default {
  extends: Popover,
  methods: {
    onMouseover() {
      this.open();
      this.ensureOnlyOnePopoverExists();
    },
    onMouseout() {
      // Don't ever close automatically
    },
    ensureOnlyOnePopoverExists() {
      setTimeout(() => {
        const allTooltipsSelector = $('div.popover');
        if (allTooltipsSelector.length > 1) {
          allTooltipsSelector.get(0).remove();
        }
      }, 50);
    }
  }
};
</script>
